/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import {
    type V1CoachBalances,
    V1CoachBalancesFromJSON,
    V1CoachBalancesToJSON
} from '../models/V1CoachBalances'
import {
    type V1CoachPayouts,
    V1CoachPayoutsFromJSON,
    V1CoachPayoutsToJSON
} from '../models/V1CoachPayouts'
import {
    type V1ErrorResponse,
    V1ErrorResponseFromJSON,
    V1ErrorResponseToJSON
} from '../models/V1ErrorResponse'
import {
    type V1MarkPayoutPaidPayload,
    V1MarkPayoutPaidPayloadFromJSON,
    V1MarkPayoutPaidPayloadToJSON
} from '../models/V1MarkPayoutPaidPayload'
import {
    type V1PaymentsHistoryResponse,
    V1PaymentsHistoryResponseFromJSON,
    V1PaymentsHistoryResponseToJSON
} from '../models/V1PaymentsHistoryResponse'
import {
    type V1PaymentsInitRequest,
    V1PaymentsInitRequestFromJSON,
    V1PaymentsInitRequestToJSON
} from '../models/V1PaymentsInitRequest'
import {
    type V1PaymentsTransaction,
    V1PaymentsTransactionFromJSON,
    V1PaymentsTransactionToJSON
} from '../models/V1PaymentsTransaction'
import {
    type V1StarsSubscription,
    V1StarsSubscriptionFromJSON,
    V1StarsSubscriptionToJSON
} from '../models/V1StarsSubscription'

export interface InitPaymentRequest {
    /**
     *
     */
    v1PaymentsInitRequest: V1PaymentsInitRequest
}

export interface MarkPayoutPaidRequest {
    /**
     *
     */
    id: string
    /**
     *
     */
    v1MarkPayoutPaidPayload: V1MarkPayoutPaidPayload
}

export interface RetryPayoutRequest {
    /**
     *
     */
    id: string
}

/**
 *
 */
export class PaymentsApi extends runtime.BaseAPI {
    /**
     * Creates request options for cancelStarsSubscription without sending the request
     */
    async cancelStarsSubscriptionRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/payments/subscription/cancel`

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * Pro stays until the end of the paid period. Cancelling again returns the same state, and so does a renewal already cancelled in Telegram. Errors: 404 code 3060 (no subscription), 409 code 3061 (refunded or expired), 409 code 3062 (Telegram refused for good), 5xx code 3062 (not cancelled, retry).
     * Stop the renewal of the Stars subscription
     */
    async cancelStarsSubscriptionRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1StarsSubscription>> {
        const requestOptions = await this.cancelStarsSubscriptionRequestOpts()
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1StarsSubscriptionFromJSON(jsonValue)
        )
    }

    /**
     * Pro stays until the end of the paid period. Cancelling again returns the same state, and so does a renewal already cancelled in Telegram. Errors: 404 code 3060 (no subscription), 409 code 3061 (refunded or expired), 409 code 3062 (Telegram refused for good), 5xx code 3062 (not cancelled, retry).
     * Stop the renewal of the Stars subscription
     */
    async cancelStarsSubscription(
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1StarsSubscription> {
        const response = await this.cancelStarsSubscriptionRaw(initOverrides)
        return await response.value()
    }

    /**
     * Creates request options for getCoachBalance without sending the request
     */
    async getCoachBalanceRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/payments/coach/balance`

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * Stars earned by the coach, net of the platform fee: held inside the refund window, available for the next payout run (1st and 15th), in payouts not sent yet, and paid.
     * The signed-in coach\'s earnings per asset
     */
    async getCoachBalanceRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1CoachBalances>> {
        const requestOptions = await this.getCoachBalanceRequestOpts()
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1CoachBalancesFromJSON(jsonValue)
        )
    }

    /**
     * Stars earned by the coach, net of the platform fee: held inside the refund window, available for the next payout run (1st and 15th), in payouts not sent yet, and paid.
     * The signed-in coach\'s earnings per asset
     */
    async getCoachBalance(
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1CoachBalances> {
        const response = await this.getCoachBalanceRaw(initOverrides)
        return await response.value()
    }

    /**
     * Creates request options for getStarsSubscription without sending the request
     */
    async getStarsSubscriptionRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/payments/subscription`

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * State of the user\'s latest Stars subscription charge: whether Pro is active until periodEnd, whether renewal was cancelled, and whether the charge can be refunded (refundReason says why not).
     * The signed-in user\'s Telegram Stars subscription
     */
    async getStarsSubscriptionRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1StarsSubscription>> {
        const requestOptions = await this.getStarsSubscriptionRequestOpts()
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1StarsSubscriptionFromJSON(jsonValue)
        )
    }

    /**
     * State of the user\'s latest Stars subscription charge: whether Pro is active until periodEnd, whether renewal was cancelled, and whether the charge can be refunded (refundReason says why not).
     * The signed-in user\'s Telegram Stars subscription
     */
    async getStarsSubscription(
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1StarsSubscription> {
        const response = await this.getStarsSubscriptionRaw(initOverrides)
        return await response.value()
    }

    /**
     * Creates request options for initPayment without sending the request
     */
    async initPaymentRequestOpts(
        requestParameters: InitPaymentRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['v1PaymentsInitRequest'] == null) {
            throw new runtime.RequiredError(
                'v1PaymentsInitRequest',
                'Required parameter "v1PaymentsInitRequest" was null or undefined when calling initPayment().'
            )
        }

        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        headerParameters['Content-Type'] = 'application/json'

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/payments/init`

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: V1PaymentsInitRequestToJSON(
                requestParameters['v1PaymentsInitRequest']
            )
        }
    }

    /**
     * A Telegram Stars subscription (kind subscription, assetKind ton_stars) is refused with 409 code 1018 while the user\'s latest Stars subscription is active and renews.
     * Init payment to show addres and unique message
     */
    async initPaymentRaw(
        requestParameters: InitPaymentRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1PaymentsTransaction>> {
        const requestOptions =
            await this.initPaymentRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1PaymentsTransactionFromJSON(jsonValue)
        )
    }

    /**
     * A Telegram Stars subscription (kind subscription, assetKind ton_stars) is refused with 409 code 1018 while the user\'s latest Stars subscription is active and renews.
     * Init payment to show addres and unique message
     */
    async initPayment(
        requestParameters: InitPaymentRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1PaymentsTransaction> {
        const response = await this.initPaymentRaw(
            requestParameters,
            initOverrides
        )
        return await response.value()
    }

    /**
     * Creates request options for listCoachPayouts without sending the request
     */
    async listCoachPayoutsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/payments/coach/payouts`

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * The signed-in coach\'s payouts, newest first
     */
    async listCoachPayoutsRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1CoachPayouts>> {
        const requestOptions = await this.listCoachPayoutsRequestOpts()
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1CoachPayoutsFromJSON(jsonValue)
        )
    }

    /**
     * The signed-in coach\'s payouts, newest first
     */
    async listCoachPayouts(
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1CoachPayouts> {
        const response = await this.listCoachPayoutsRaw(initOverrides)
        return await response.value()
    }

    /**
     * Creates request options for markPayoutPaid without sending the request
     */
    async markPayoutPaidRequestOpts(
        requestParameters: MarkPayoutPaidRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling markPayoutPaid().'
            )
        }

        if (requestParameters['v1MarkPayoutPaidPayload'] == null) {
            throw new runtime.RequiredError(
                'v1MarkPayoutPaidPayload',
                'Required parameter "v1MarkPayoutPaidPayload" was null or undefined when calling markPayoutPaid().'
            )
        }

        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        headerParameters['Content-Type'] = 'application/json'

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/payments/payouts/{id}/paid`
        urlPath = urlPath.replace(
            '{id}',
            encodeURIComponent(String(requestParameters['id']))
        )

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: V1MarkPayoutPaidPayloadToJSON(
                requestParameters['v1MarkPayoutPaidPayload']
            )
        }
    }

    /**
     * Admin: record a payout confirmed by hand as paid
     */
    async markPayoutPaidRaw(
        requestParameters: MarkPayoutPaidRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<{ [key: string]: any }>> {
        const requestOptions =
            await this.markPayoutPaidRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse<any>(response)
    }

    /**
     * Admin: record a payout confirmed by hand as paid
     */
    async markPayoutPaid(
        requestParameters: MarkPayoutPaidRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<{ [key: string]: any }> {
        const response = await this.markPayoutPaidRaw(
            requestParameters,
            initOverrides
        )
        return await response.value()
    }

    /**
     * Creates request options for paymentsHistory without sending the request
     */
    async paymentsHistoryRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/payments/history`

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * history of user\'s payments
     */
    async paymentsHistoryRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1PaymentsHistoryResponse>> {
        const requestOptions = await this.paymentsHistoryRequestOpts()
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1PaymentsHistoryResponseFromJSON(jsonValue)
        )
    }

    /**
     * history of user\'s payments
     */
    async paymentsHistory(
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1PaymentsHistoryResponse> {
        const response = await this.paymentsHistoryRaw(initOverrides)
        return await response.value()
    }

    /**
     * Creates request options for payoutPreflight without sending the request
     */
    async payoutPreflightRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/payments/payouts/preflight`

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * Admin: can the payout wallet cover the open payouts and the next run?
     */
    async payoutPreflightRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<{ [key: string]: any }>> {
        const requestOptions = await this.payoutPreflightRequestOpts()
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse<any>(response)
    }

    /**
     * Admin: can the payout wallet cover the open payouts and the next run?
     */
    async payoutPreflight(
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<{ [key: string]: any }> {
        const response = await this.payoutPreflightRaw(initOverrides)
        return await response.value()
    }

    /**
     * Creates request options for refundStarsSubscription without sending the request
     */
    async refundStarsSubscriptionRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/payments/subscription/refund`

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * Allowed within the paid period when none of the user\'s schedules of started programmes and workouts (deleted ones included) was saved since the charge. Cancels the renewal, refunds the Stars and ends Pro immediately; the response carries a new session token without Pro, which the app must store. Safe to repeat: a refunded charge returns the same state and a new token, and a refund that failed after Telegram returned the Stars is finished by the next call. Errors: 404 code 3060 (no subscription), 409 code 3064 (not refundable), 409 codes 3062/3065 (Telegram refused for good: the renewal stays as it was, nothing refunded), 5xx codes 3062/3063/3065/ 3067 (nothing refunded yet, retry) and 3066 (refunded, finishing failed: retry to get the token).
     * Refund the latest Stars subscription charge and end Pro now
     */
    async refundStarsSubscriptionRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<V1StarsSubscription>> {
        const requestOptions = await this.refundStarsSubscriptionRequestOpts()
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            V1StarsSubscriptionFromJSON(jsonValue)
        )
    }

    /**
     * Allowed within the paid period when none of the user\'s schedules of started programmes and workouts (deleted ones included) was saved since the charge. Cancels the renewal, refunds the Stars and ends Pro immediately; the response carries a new session token without Pro, which the app must store. Safe to repeat: a refunded charge returns the same state and a new token, and a refund that failed after Telegram returned the Stars is finished by the next call. Errors: 404 code 3060 (no subscription), 409 code 3064 (not refundable), 409 codes 3062/3065 (Telegram refused for good: the renewal stays as it was, nothing refunded), 5xx codes 3062/3063/3065/ 3067 (nothing refunded yet, retry) and 3066 (refunded, finishing failed: retry to get the token).
     * Refund the latest Stars subscription charge and end Pro now
     */
    async refundStarsSubscription(
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<V1StarsSubscription> {
        const response = await this.refundStarsSubscriptionRaw(initOverrides)
        return await response.value()
    }

    /**
     * Creates request options for retryPayout without sending the request
     */
    async retryPayoutRequestOpts(
        requestParameters: RetryPayoutRequest
    ): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling retryPayout().'
            )
        }

        const queryParameters: any = {}

        const headerParameters: runtime.HTTPHeaders = {}

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken
            const tokenString = await token('bearerAuth', [])

            if (tokenString) {
                headerParameters['Authorization'] = `Bearer ${tokenString}`
            }
        }

        let urlPath = `/api/v1/payments/payouts/{id}/retry`
        urlPath = urlPath.replace(
            '{id}',
            encodeURIComponent(String(requestParameters['id']))
        )

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters
        }
    }

    /**
     * Admin: put a failed or stuck payout back to pending for the next run
     */
    async retryPayoutRaw(
        requestParameters: RetryPayoutRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<runtime.ApiResponse<{ [key: string]: any }>> {
        const requestOptions =
            await this.retryPayoutRequestOpts(requestParameters)
        const response = await this.request(requestOptions, initOverrides)

        return new runtime.JSONApiResponse<any>(response)
    }

    /**
     * Admin: put a failed or stuck payout back to pending for the next run
     */
    async retryPayout(
        requestParameters: RetryPayoutRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction
    ): Promise<{ [key: string]: any }> {
        const response = await this.retryPayoutRaw(
            requestParameters,
            initOverrides
        )
        return await response.value()
    }
}
